import getLang from 'I18n/utils/getLang';
import { apiClientProvider } from '../utils/apiClient';
let marketplaceSearchBase = 'marketplace-search/v1';
export const setMarketplaceSearchBase = base => {
  marketplaceSearchBase = base;
};
export const marketplaceSearchProfiles = apiClientProvider((apiClient, query) => {
  // Extend timeout for requests, especially important for Australia region
  const requestOptions = {
    data: [Object.assign({}, query, {
      callingUserLanguage: getLang()
    })],
    timeout: 30000 // 30 seconds timeout
  };
  return apiClient.post(`${marketplaceSearchBase}/profiles/search`, requestOptions);
});
export const marketplaceSearchProfilesMulti = apiClientProvider((apiClient, queries) => {
  // Apply same extended timeout for multi-profile search
  const requestOptions = {
    data: queries,
    timeout: 30000 // 30 seconds timeout
  };
  return apiClient.post(`${marketplaceSearchBase}/profiles/search`, requestOptions);
});